import { Text } from '@vkontakte/vkui';
import React from 'react';
import { discountOnRemove } from 'reactApp/appHelpers/featuresHelpers/features/discountOnRemove';
import { DiscountOnRemoveBanner } from 'reactApp/ui/DiscountOnRemoveModal/DiscountOnRemoveBanner';
import { OverquotaInfoBlock } from 'reactApp/ui/OverquotaInfoBlock/OverquotaInfoBlock';

import styles from './DiscountOnRemoveModal.css';

export const useContent = () => {
    let image = <OverquotaInfoBlock showWarningIcon />;

    const title = 'Увеличить место в\u00A0Облаке можно без\u00A0удаления файлов';

    let text = (
        <>
            Добавьте в&nbsp;Облако {discountOnRemove.tariffQuota.value} с&nbsp;подпиской Mail Space&nbsp;&mdash; и&nbsp;все&nbsp;нужные
            файлы останутся с&nbsp;вами
        </>
    );

    const cancelButton = 'Всё равно удалить';

    let successButton = 'Сохранить файлы';

    if (discountOnRemove.isTrial) {
        image = <DiscountOnRemoveBanner text={'Решение за\u00A00\u00A0₽'} />;

        text = (
            <>
                Добавьте в&nbsp;Облако {discountOnRemove.tariffQuota.value} с&nbsp;подпиской Mail Space&nbsp;&mdash; бесплатно на 30 дней.
                И&nbsp;все нужные файлы останутся с&nbsp;вами
            </>
        );
        successButton = 'Сохранить файлы за\u00A00\u00A0₽';
    }
    if (discountOnRemove.isDiscount) {
        image = <DiscountOnRemoveBanner text={`скидка ${discountOnRemove.tariffDiscountValue}%`} />;

        text = (
            <>
                Добавьте в&nbsp;Облако {discountOnRemove.tariffQuota.value} с&nbsp;подпиской Mail Space&nbsp;&mdash; со&nbsp;скидкой{' '}
                {discountOnRemove.tariffDiscountValue}%. И&nbsp;все нужные файлы останутся с&nbsp;вами
            </>
        );
        successButton = 'Сохранить со\u00A0скидкой';
    }

    return { image, title, content: <Text className={styles.text}>{text}</Text>, cancelButton, successButton };
};
